import React from 'react';
import Cookies from 'js-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connectToWebSocket, disconnectWebSocket } from '../services/subscriptionSocket';

class WebSocketNotifier extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAppFrozen: false,
      // planUpdateData: null,
      animationPhase: 'entering'
    };
  }

  componentDidMount() {
    const frozenState = localStorage.getItem('appFrozenForPlanUpdate');
    if (frozenState) {
      // const frozenData = JSON.parse(frozenState);
      this.setState({ 
        isAppFrozen: true, 
        // planUpdateData: frozenData,
        animationPhase: 'visible'
      });
      this.preventNavigation();
      return;
    }

    try {
      const userCookie = Cookies.get('userInfo');
      const userInfo = userCookie ? JSON.parse(userCookie) : null;
      const customerId = userInfo?.customerId;

      if (customerId) {
        connectToWebSocket(customerId, this.handleWebSocketMessage);
      }
    } catch (err) {
      console.error('Error reading userInfo from cookies:', err);
    }
  }

  componentWillUnmount() {
    disconnectWebSocket();
    this.removeNavigationPrevention();
  }

  preventNavigation = () => {
    const preventNavigation = (e) => {
      e.preventDefault();
      e.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', preventNavigation);
    window.addEventListener('popstate', this.handlePopState);
    this.preventNavigationHandler = preventNavigation;

    const preventKeyboardShortcuts = (e) => {
      if ((e.ctrlKey && e.key === 'r') || (e.ctrlKey && e.key === 'R')) {
        e.preventDefault();
        return false;
      }
      return true;
    };

    document.addEventListener('keydown', preventKeyboardShortcuts, true);
    this.preventKeyboardHandler = preventKeyboardShortcuts;
    window.history.pushState({ frozen: true }, '', window.location.href);
  };

  removeNavigationPrevention = () => {
    if (this.preventNavigationHandler) {
      window.removeEventListener('beforeunload', this.preventNavigationHandler);
    }
    if (this.preventKeyboardHandler) {
      document.removeEventListener('keydown', this.preventKeyboardHandler, true);
    }
    window.removeEventListener('popstate', this.handlePopState);
  };

  handlePopState = () => {
    const { isAppFrozen } = this.state;
    if (isAppFrozen) {
      window.history.pushState({ frozen: true }, '', window.location.href);
    }
  };

  handleWebSocketMessage = (data) => {
    if (data?.eventType === 'SubscriptionUpdated') {
      localStorage.setItem('appFrozenForPlanUpdate', JSON.stringify(data.data));
      
      this.setState({ 
        isAppFrozen: true, 
        // planUpdateData: data.data,
        animationPhase: 'entering'
      });

      setTimeout(() => {
        this.setState({ animationPhase: 'visible' });
      }, 100);

      this.preventNavigation();
    }
  };

  handleReloginRedirect = () => {
    this.setState({ animationPhase: 'exiting' });
    
    setTimeout(() => {
      localStorage.removeItem('appFrozenForPlanUpdate');
      this.removeNavigationPrevention();
      
      Cookies.remove('accessToken');
      Cookies.remove('userData');
      Cookies.remove('features');
      Cookies.remove('userInfo');
      Cookies.remove('userEmail');
      
      const keysToKeep = [];
      const allKeys = Object.keys(localStorage);
      allKeys.forEach(key => {
        if (!keysToKeep.includes(key)) {
          localStorage.removeItem(key);
        }
      });
      
      toast.dismiss();
      window.location.replace('/auth/login');
    }, 500);
  };

  render() {
    const { isAppFrozen,  animationPhase } = this.state;
    
    return (
      <>
        {isAppFrozen && (
          <div
            className={`freeze-overlay freeze-overlay--${animationPhase}`}
            onContextMenu={(e) => e.preventDefault()}
          >
            <div className="particles">
              {[...Array(8)].map((_, i) => (
                <div 
                  key={i} 
                  className="particle" 
                  style={{
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 3}s`,
                    animationDuration: `${3 + Math.random() * 2}s`
                  }}
                />
              ))}
            </div>

            <div className={`upgrade-modal upgrade-modal--${animationPhase}`}>
              <div className="icon-container">
                <div className="success-circle">
                  <div className="rocket-icon">
                    <span role="img" aria-label="rocket">🚀</span>
                  </div>
                </div>
                <div className="celebration-sparks">
                  {[...Array(4)].map((_, i) => (
                    <div 
                      key={i} 
                      className="spark" 
                      style={{
                        transform: `rotate(${i * 90}deg)`,
                        animationDelay: `${i * 0.1}s`
                      }}
                    />
                  ))}
                </div>
              </div>

              <div className="modal-content">
                <h1 className="modal-title">
                  <span role="img" aria-label="celebration">🎉</span> There have been some changes to your HRMS.
                </h1>
                
                {/* <div className="plan-info">
                  <div className="plan-badge">
                    <span className="plan-name">{planUpdateData?.planName}</span>
                  </div>
                </div> */}

                <p className="modal-description">
                  Please re-login to access your upgraded features.
                </p>

                <button
                  type="button"
                  onClick={this.handleReloginRedirect}
                  className="login-button"
                >
                  <span className="button-icon" role="img" aria-label="lock">🔐</span>
                  <span>Proceed</span>
                </button>

                <p className="security-note">
                  <span className="security-icon" role="img" aria-label="shield">🛡️</span>
                  Navigation disabled for security
                </p>
              </div>
            </div>
          </div>
        )}

        <ToastContainer />
        
        <style>
          {`
            .freeze-overlay {
              position: fixed;
              top: 0;
              left: 0;
              width: 100vw;
              height: 100vh;
              background: rgba(0,0,0,0.7);
              z-index: 999999;
              display: flex;
              justify-content: center;
              align-items: center;
              backdrop-filter: blur(5px);
              user-select: none;
              overflow: hidden;
            }

            .freeze-overlay--entering {
              opacity: 0;
              animation: fadeIn 0.3s ease-out forwards;
            }

            .freeze-overlay--visible {
              opacity: 1;
            }

            .freeze-overlay--exiting {
              animation: fadeOut 0.3s ease-in forwards;
            }

            @keyframes fadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }

            @keyframes fadeOut {
              from { opacity: 1; }
              to { opacity: 0; }
            }

            .particles {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              pointer-events: none;
            }

            .particle {
              position: absolute;
              width: 2px;
              height: 2px;
              background: rgba(255, 255, 255, 0.6);
              border-radius: 50%;
              animation: float linear infinite;
            }

            @keyframes float {
              0% {
                transform: translateY(100vh) rotate(0deg);
                opacity: 0;
              }
              10% {
                opacity: 1;
              }
              90% {
                opacity: 1;
              }
              100% {
                transform: translateY(-10vh) rotate(360deg);
                opacity: 0;
              }
            }

            .upgrade-modal {
              background: white;
              border-radius: 12px;
              padding: 24px;
              max-width: 380px;
              width: 90%;
              margin: 20px;
              box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
              position: relative;
              text-align: center;
              border: 1px solid rgba(0, 0, 0, 0.1);
            }

            .upgrade-modal--entering {
              opacity: 0;
              transform: scale(0.9) translateY(-20px);
              animation: modalEnter 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
            }

            .upgrade-modal--visible {
              opacity: 1;
              transform: scale(1) translateY(0);
            }

            .upgrade-modal--exiting {
              animation: modalExit 0.3s ease-in forwards;
            }

            @keyframes modalEnter {
              to {
                opacity: 1;
                transform: scale(1) translateY(0);
              }
            }

            @keyframes modalExit {
              to {
                opacity: 0;
                transform: scale(0.9) translateY(20px);
              }
            }

            .icon-container {
              position: relative;
              margin-bottom: 16px;
            }

            .success-circle {
              width: 70px;
              height: 70px;
              border-radius: 50%;
              background: linear-gradient(135deg, #10b981, #059669);
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0 auto;
              box-shadow: 0 5px 15px rgba(16, 185, 129, 0.3);
              animation: successPulse 2s ease-in-out infinite;
            }

            .rocket-icon {
              font-size: 28px;
              animation: rocketBounce 1.5s ease-in-out infinite;
            }

            @keyframes successPulse {
              0%, 100% { transform: scale(1); }
              50% { transform: scale(1.05); }
            }

            @keyframes rocketBounce {
              0%, 100% { transform: translateY(0); }
              50% { transform: translateY(-5px); }
            }

            .celebration-sparks {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 120px;
              height: 120px;
              pointer-events: none;
            }

            .spark {
              position: absolute;
              top: 50%;
              left: 50%;
              width: 2px;
              height: 12px;
              background: linear-gradient(to bottom, #fbbf24, #f59e0b);
              border-radius: 2px;
              transform-origin: center bottom;
              animation: sparkle 1.5s ease-in-out infinite;
            }

            @keyframes sparkle {
              0%, 100% { 
                opacity: 0;
                transform: translateY(0) scale(0);
              }
              50% { 
                opacity: 1;
                transform: translateY(-40px) scale(1);
              }
            }

            .modal-content {
              position: relative;
              z-index: 1;
            }

            .modal-title {
              font-size: 20px;
              font-weight: 700;
              color: #1f2937;
              margin: 0 0 8px 0;
            }

            .plan-info {
              margin-bottom: 16px;
            }

            .plan-badge {
              display: inline-block;
              background: linear-gradient(135deg, #3b82f6, #1d4ed8);
              padding: 6px 12px;
              border-radius: 8px;
              box-shadow: 0 3px 10px rgba(59, 130, 246, 0.2);
            }

            .plan-name {
              font-size: 14px;
              font-weight: 600;
              color: white;
            }

            .modal-description {
              font-size: 13px;
              line-height: 1.5;
              color: #4b5563;
              margin-bottom: 20px;
            }

            .login-button {
              background: linear-gradient(135deg, #10b981, #059669);
              color: white;
              border: none;
              padding: 10px 20px;
              border-radius: 8px;
              font-size: 13px;
              font-weight: 600;
              cursor: pointer;
              display: inline-flex;
              align-items: center;
              gap: 8px;
              transition: all 0.2s ease;
              box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
              margin-bottom: 16px;
              min-width: 160px;
              justify-content: center;
            }

            .login-button:hover {
              transform: translateY(-1px);
              box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);
            }

            .button-icon {
              font-size: 14px;
            }

            .security-note {
              font-size: 11px;
              color: #6b7280;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 6px;
              margin: 0;
              padding: 6px;
              background: rgba(107, 114, 128, 0.05);
              border-radius: 6px;
            }

            .security-icon {
              font-size: 12px;
            }

            /* Disable scrolling when frozen */
            ${isAppFrozen ? `
              body, html {
                overflow: hidden !important;
                height: 100% !important;
              }
            ` : ''}
          `}
        </style>
      </>
    );
  }
}

export default WebSocketNotifier;